export const MeetingResultFragment = gql`
  fragment MeetingResultFragment on MeetingResult {
    id
    name
  }
`
